export default "__VITE_ASSET__CEisOtB9__";